import { Sparkles, MessageSquare, Zap, BarChart, Users } from "lucide-react";
import { useTheme } from "@/contexts/ThemeContext";

const MostPopularFeatures = () => {
  const { theme } = useTheme();
  const isDark = theme === 'dark';

  const popularFeatures = [
    {
      icon: MessageSquare,
      title: "Unified Conversations",
      description: "Manage all customer communications from one powerful inbox across email, SMS, social media, and web chat."
    },
    {
      icon: Zap,
      title: "Workflow Automation",
      description: "Automate repetitive tasks and create intelligent follow-up sequences that nurture leads on autopilot."
    },
    {
      icon: Sparkles,
      title: "Native AI Tools",
      description: "AI-powered assistance for conversations, content creation, review management, and phone calls."
    },
    {
      icon: BarChart,
      title: "CRM & Pipelines",
      description: "Track every lead, deal, and customer interaction with visual pipelines and smart lead scoring."
    },
    {
      icon: Users,
      title: "Client Sub-Accounts",
      description: "Manage multiple brands or client accounts from one dashboard—perfect for agencies and enterprises."
    }
  ];

  return (
    <section className="py-16">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          {/* Badge with animated border */}
          <div className="flex justify-center mb-4">
            <div className="relative inline-flex items-center gap-1 px-2.5 py-1 rounded-full overflow-hidden">
              {/* Animated border trace - uses global CSS animation */}
              <div className="absolute inset-0 rounded-full badge-animated-border" />
              {/* Static border */}
              <div 
                className="absolute inset-0 rounded-full"
                style={{ border: `1px solid ${isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.15)'}` }}
              />
              <div 
                className="absolute inset-0 rounded-full"
                style={{ border: `1px solid ${isDark ? 'rgba(255,255,255,0.15)' : 'rgba(0,0,0,0.15)'}` }}
              />
              <div 
                className="absolute inset-[1px] rounded-full"
                style={{ backgroundColor: isDark ? '#1A1A1A' : '#FCFCF9' }}
              />
              <Sparkles 
                className="relative z-10 w-3 h-3" 
                style={{ color: isDark ? '#AAAAAA' : '#555555' }}
              />
              <span 
                className="relative z-10 text-xs font-medium"
                style={{ color: isDark ? '#FFFFFF' : '#111111' }}
              >
                Popular
              </span>
            </div>
          </div>
          
          <h2 
            className="text-3xl lg:text-4xl font-bold mb-3"
            style={{ color: isDark ? '#FFFFFF' : '#111111' }}
          >
            Most Popular Features.
          </h2>
          <p 
            className="text-sm max-w-2xl mx-auto"
            style={{ color: isDark ? '#AAAAAA' : '#555555' }}
          >
            The tools our customers use every day to grow their businesses.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          {popularFeatures.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <div 
                key={index}
                className="rounded-xl p-5 transition-all duration-300 hover:shadow-lg hover:scale-[1.02] group cursor-pointer"
                style={{ 
                  backgroundColor: isDark ? '#1A1A1A' : '#FFFFFF',
                  border: `1px solid ${isDark ? 'rgba(255,255,255,0.1)' : '#E0E0E0'}`
                }}
              >
                <div 
                  className="w-10 h-10 rounded-lg flex items-center justify-center mb-4 mx-auto transition-colors"
                  style={{ backgroundColor: isDark ? 'rgba(255,255,255,0.05)' : '#F8F8F8' }}
                >
                  <Icon 
                    className="w-5 h-5" 
                    style={{ color: isDark ? '#FFFFFF' : '#111111' }}
                  />
                </div>
                <h3 
                  className="text-sm font-semibold mb-2 text-center"
                  style={{ color: isDark ? '#FFFFFF' : '#111111' }}
                >
                  {feature.title}
                </h3>
                <p 
                  className="text-xs leading-relaxed text-center"
                  style={{ color: isDark ? '#AAAAAA' : '#555555' }}
                >
                  {feature.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default MostPopularFeatures;
